/* eslint no-use-before-define: 0 */

import $ from "jquery";
import Rx from "rxjs/Rx";

import { searchRequested$, newSearchDone$ } from "@sharedFrontend/globalEvents";

import { TypeFiltersPanelComponent } from "./type-filters-panel.component";
import { AreaFiltersPanelComponent } from "./area-filters-panel.component";
import { TabSwitcherComponent } from "./tab-switcher.component";
import HelperTextComponent from "./nothing-selected-helper-text.component";

const searchButtonClickedSource = new Rx.Subject();
const enterKeyPressedSource = new Rx.Subject();
export const searchButtonClicked$ = searchButtonClickedSource.asObservable();
export const enterKeyPressed$ = enterKeyPressedSource.asObservable();

export class SearchPanelComponent {
    /**
     * @param {Object} node - Jquery node. Unique for every SearchPanelComponent class instance.
     */
    constructor(node, isFrontPageComponent, options) {
        this.node = node;
        this.typeFiltersPanel = null;
        this.areaFiltersPanel = null;
        this.options = null;
        this.isFrontPageComponent = isFrontPageComponent !== undefined ? isFrontPageComponent : false;
        if (this.isFrontPageComponent) {
            this.redirectionLinkBase = this.node.data("redirection-page");
        }

        if (options) {
            this.options = options;
        }

        this.initialize();
    }

    static get inputText() {
        const searchInputId = "search-input";
        return $(`#${searchInputId}`).val();
    }

    initialize() {
        if (this.options && this.options.noFilters) {
            this.initializeEventHandlers();
            return;
        }

        this.initializeChildComponents();
        this.initializeEventHandlers();
    }

    initializeChildComponents() {
        const scope = this;

        initializeAreaFiltersPanel();
        initializeTypeFiltersPanel();
        initializeTabSwitcher();
        initializeHelperText();

        function initializeAreaFiltersPanel() {
            const areaPanelNode = scope.node.find(".custom-area-filters-panel-component");
            if (areaPanelNode.length) {
                scope.areaFiltersPanel = new AreaFiltersPanelComponent(areaPanelNode.eq(0), scope.node);
            } else {
                scope.areaFiltersPanel = new AreaFiltersPanelComponent(null, scope.node);
            }
        }

        function initializeTypeFiltersPanel() {
            const typePanelNode = scope.node.find(".custom-type-filter-panel-component");
            if (typePanelNode.length) {
                scope.typeFiltersPanel = new TypeFiltersPanelComponent(
                    typePanelNode.eq(0),
                    scope.isFrontPageComponent,
                    scope.redirectionLinkBase,
                );
            }
        }

        function initializeTabSwitcher() {
            const tabSwitcherNode = scope.node.find(".custom-search-panel-panel-switcher");
            if (tabSwitcherNode.length) {
                scope.tabSwitcher = new TabSwitcherComponent(tabSwitcherNode.eq(0));
            }
        }

        function initializeHelperText() {
            const helperText = scope.node.find(".tabs-section-content .helper-text");
            if (helperText.length) {
                scope.helperText = new HelperTextComponent(helperText.eq(0));
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    initializeEventHandlers() {
        function subscribeOnSearchButtonClicked$() {
            $("#search-button").on("click", () => {
                searchButtonClickedSource.next();
            });
        }

        function subscribeOnSearchRequested$() {
            searchRequested$.subscribe(() => {
                renderLoader();
            });

            function renderLoader() {
                $(".search-container-search-button-number-text").html("<div class=\"loader\"></div>");
            }
        }

        function subscribeOnNewSearchDone$() {
            newSearchDone$.subscribe((results) => {
                renderAmountOfSearchResults(results);
            });

            function renderAmountOfSearchResults(results) {
                $(".search-container-search-button-number-text").html(`(${results.length})`);
            }
        }

        function subscribeOnDocumentEnterKeyPressed$() {
            $(document).keypress((event) => {
                const keycode = event.keyCode ? event.keyCode : event.which;
                if (keycode === 13) {
                    document.activeElement.blur();
                    enterKeyPressedSource.next();
                }
            });
        }

        subscribeOnSearchButtonClicked$();
        subscribeOnSearchRequested$();
        subscribeOnNewSearchDone$();
        subscribeOnDocumentEnterKeyPressed$();
    }
}

function enableSearchPanel() {
    const input = $("#search-input");
    const placeholderText = input.attr("data-placeholder");
    input
        .attr("disabled", null)
        .attr("placeholder", placeholderText);
}

document.addEventListener("cookies-accept:required", () => enableSearchPanel());
